import { useTranslation } from 'react-i18next'

import { DetalhesClienteAtendimento } from '@/features/atendimento/components/detalhes-cliente-atendimento'
import { IdentificadorClienteAtendimento } from '@/features/atendimento/components/identificador-cliente-atendimento'
import { useAtendimento } from '@/features/atendimento/hooks'
import type { TAtendimento } from '@/features/atendimento/interfaces'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/shared/components/ui'
import { useGuardedHandler } from '@/shared/hooks/use-guarded-handlers'
import { checkOnlineGuard, confirmDialogGuard } from '@/shared/utils'

const AtendimentoDropdownMenu = ({ cliente }: { cliente: TAtendimento['cliente'] }) => {
  const { t } = useTranslation('atendimento')
  const { handleEncerrarAtendimento } = useAtendimento()
  const handleEncerrarAtendimentoGuarded = useGuardedHandler(
    [
      checkOnlineGuard(),
      confirmDialogGuard({
        title: t('components.atendimento_dropdown.titulo'),
        description: t('components.atendimento_dropdown.descricao'),
      }),
    ],
    handleEncerrarAtendimento,
  )

  return (
    <div className="dropdown-container relative z-50">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="bg-foreground shadow-cz max-w-70 justify-start px-2 py-2.5">
            <IdentificadorClienteAtendimento nome={cliente.nome} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="flex w-70 flex-col gap-2">
          <DropdownMenuLabel className="text-base font-medium">
            {t('components.atendimento_info.o_que_fazer')}
          </DropdownMenuLabel>
          <DropdownMenuGroup className="font-nunito [&>div]:h-11">
            <DropdownMenuSub>
              <DropdownMenuSubTrigger>{t('components.atendimento_info.ver_detalhes')}</DropdownMenuSubTrigger>
              <DropdownMenuPortal>
                <DropdownMenuSubContent className="mr-2">
                  <DetalhesClienteAtendimento cliente={cliente} />
                </DropdownMenuSubContent>
              </DropdownMenuPortal>
            </DropdownMenuSub>
            <DropdownMenuItem onClick={handleEncerrarAtendimentoGuarded}>
              {t('components.atendimento_info.encerrar_atendimento')}
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}

export { AtendimentoDropdownMenu }
